import { useContext, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Page, Msg, LoadMore, Toast, Panel } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import EnumService from 'services/enum2';
import { WORKFLOW_CONFIG } from '../constants/workflow2.ts';
import { BILLTYPE_MAP } from '../constants/billType.ts';
import TopNav from 'components/topNav.jsx';
import * as MobileActions from 'actions/index.ts';
import CommonFns from 'functions/common.ts';
import useList from 'hooks/useList';
import User from 'services/user2';
import Modal from 'components/modal';

//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import { ActionContext } from 'actions/context';

/**    有单据详情的审批
    采购单("10","purchaesOrder"),
    采购变更单("11","changeOrder"),
    收货单("12","receiveOrder"),
    入库单("13","storageOrder"),
    退货单("14","returnOrder"),
    检验单("15","checkOrder"),
    交料通知单("16","answerChangeNoticeOrder"),
    工装转移单("17","toolingsOrder"),
    样品追踪单("18","sampleTrackOrder"),
    请购单("19","requisitionOrder"),
    客户采购单("20","customerPurchaseOrder"), //阅读状态时使用
    客户采购变更单("21","customerChangeOrder"),//阅读状态时使用
    出货通知单("22","deliveryOrder"),
    核价单("23","pricingOrder"),
    客户退货单("24","customerReturnOrder"),//阅读状态时使用
    延迟送货申请单("26","applyDeliveryOrder"),
    Eight报告("27","verifyP8DReport"),
    物流竞价单("28","logisticsBiddingOrder"),
    正式供应商("29","compVendor"),
    排程("30","scheduleOrder"),
    生产计划("31","productionOrder"),
    预检申请单("32","preverifyApplyOrder"),
    物料准入报告("33","materialOrder"),
    质量目标追踪("34","qualityTrackOrder"),
    销售_变更单("35","saleChangeOrder"),
    出货_出库单("36","outCargoOrder"),// 出货OR出库
    销售_退货单("37","saleReturnOrder"),
    销售_对账单("38","saleStatementOrder"),
    销售_发票单("39","saleInvoiceOrder"),
    合同("40","contractOrder"),
    资质("41","certificatesOrder"),
    资源申请单("42","resourcePoolOrder"),
    供应商处罚通知单("43","vendorPunishNotice"),
    供应商退出通知("44","vendorEliminateNotice"),
    供应商信息变更("45","companyChanged"),
    询价("50","inquiryOrder"),
    报价("51","quoteOrder"),
    对账单("52","statementOrder"),
    发票单("53","invoiceOrder"),
    费用单("54","costsheetOrder"),
    竞价单("55","biddingOrder"),
    竞价_预报价单("56","biddingOrder2"),//公开竞价时，未在供应商列表中的外部企业参与竞价时使用
    转移单("57","toolsTransfer"),//公开竞价时，未在供应商列表中的外部企业参与竞价时使用
    商机("58","opportunityOrder"),
    比价单("59","priceCompareOrder"),
    预付款单("60","prepaymentsOrder"),
    付款申请("61","paymentApply"),//供应商创建“提前付款申请”时也使用这个枚举
    付款计划("62","paymentPlan"),
    支付申请("63","paymoneyApply"),
    付款单("64","receiptOrder"),
    预付退款单("65","prepayReturnOrder"),
    预付结转单("66","prepayTransferOrder"),
    销售订单("67","saleOrder"),
    金融票据("68","financialBill"),
    ECN报告("69","ecnReport"),
    需求单("70","innerInquiryOrder"),
    项目招标单("71","projectBiddingOrder"),
    项目投标单("72","projectQuoteOrder"),
    供应商准入评估报告("73","admissionReport"),
    引入单("74","introduceOrder"),
    采购验收单("76","accpOrder"),
    岗位权限("80","sysRole"),
    多物料竞价("84","biddingOrder"),
    服务购买单("90","serviceOrder"),
  */
const linkBillTypes = [
  '10',
  '11',
  '12',
  '15',
  '19',
  '23',
  '26',
  '27',
  '28',
  '33',
  '43',
  '44',
  '45',
  '50',
  '52',
  '53',
  '54',
  '55',
  '58',
  '59',
  '60',
  '61',
  '64',
  '70',
  '71',
  '73',
  '76',
  '84',
  '87'
];
const wfmConfig = WORKFLOW_CONFIG;

/**
 * 待审批列表
 *
 */
function ApproveList(props) {
  const Config = {
    purchase: {
      apiPath: '/workflowBills/order/getCheckInfoList',
      orderProperty: 'createTime',
      detailLink: '',
      arrEnumField: [
        {
          mainKey: 'B02_Bills_Approval_Status',
          subKey: 'checkedStatus',
          value: 'checkedStatusName'
        },
        {
          mainKey: 'B02_Common_Bill_Type',
          subKey: 'billType',
          value: 'billTypeName'
        }
      ],
      tabs: ['待审批', '我发起的', '全部'],
      tabConfig: [
        0, //待审批
        1, //我发起的
        2 //全部
      ]
    }
  };
  const config = Config[props.type];

  const { state, dispatch } = useContext(ActionContext);

  const {
    companyCode,
    decimalPlace,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  self.listTransform = async function (arr) {
    if (Array.isArray(arr)) {
      for (let item of arr) {
        // 显示单据状态
        if (BILLTYPE_MAP[item.billType]) {
          let mainKey = BILLTYPE_MAP[item.billType].mainKey;
          if (mainKey) {
            await EnumService.getValue(mainKey, item.billStatus).then(value => {
              item['billStatusName'] = value;
            });
          }
        }
      }
    }
  };

  //companyCode改变时执行
  useEffect(() => {
    if (Array.isArray(list)) {
      for (let item of list) {
        //组装审批人
        if (item.checkedStatus === 0) {
          //已审批
          if (Array.isArray(item.curAuthTitles)) {
            item.approver = item.curAuthTitles.join('，');
          }
        } else {
          //未审批
          if (Array.isArray(item.approvals)) {
            item.approver = item.approvals
              .map(row => {
                return row.curRoleName
                  ? row.curRoleName + '-' + row.checkEmpName
                  : row.checkEmpName;
              })
              .join('，');
          }
        }
        //审批按钮
        item.arrBtn = [
          {
            checkStatus: 1,
            toWfnXkCode: item.toWfnXkCode,
            btnName: '同意'
          },
          {
            checkStatus: 0,
            toWfnXkCode: item.toWfnXkCode,
            btnName: '拒绝'
          }
        ];
      }
    }
  }, [companyCode, list, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //刷新页面
  useEffect(() => {
    self.search(true, 1);
  }, [state.refreshTs, self]);

  //扩展搜索参数
  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        optValue: config.tabConfig[currentTab]
      };
    }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            {/* 列表项 */}
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <div key={index} className="content-line line-list-item">
                      <div className="line-list-item-title">
                        <span>{item.billTypeName}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'approval',
                                item.checkedStatus
                              )
                            }
                          >
                            {item.checkedStatusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>企业名称</label>
                          <div>{item.companyName}</div>
                        </li>
                        <li>
                          <label>供应商</label>
                          <div>{item.vendorName}</div>
                        </li>
                        <li>
                          <label>单据编号</label>
                          <div>
                            {!linkBillTypes.includes(item.billType) && (
                              <span>{item.billInnerNo}</span>
                            )}
                            {linkBillTypes.includes(item.billType) &&
                              wfmConfig[item.wfmCode] &&
                              (companyCode === item.companyCode ? (
                                <Link
                                  to={`/mp${
                                    wfmConfig[item.wfmCode].linkPrefix
                                  }${item.companyCode}/${item.billXkNo}`}
                                >
                                  {item.billInnerNo}
                                </Link>
                              ) : (
                                <Link
                                  to={`/mp/index?companyCode=${
                                    item.companyCode
                                  }&path=${
                                    '/mp' + wfmConfig[item.wfmCode].linkPrefix
                                  }${item.companyCode}/${item.billXkNo}`}
                                >
                                  {item.billInnerNo}
                                </Link>
                              ))}
                          </div>
                        </li>
                        <li>
                          <label>合计金额</label>
                          <div>
                            {formatNumber(
                              item.orderTotAmount,
                              item.Amount_Decimal_Place
                            ) || '--'}
                          </div>
                        </li>
                        <li>
                          <label>单据状态</label>
                          <div>{item.billStatusName}</div>
                        </li>
                        <li>
                          <label>建单人</label>
                          <div>{item.billCreateName}</div>
                        </li>
                        <li>
                          <label>审批关</label>
                          <div>{item.curNodeName}</div>
                        </li>
                        <li>
                          <label>审批人</label>
                          <div>{item.approver}</div>
                        </li>
                        <li>
                          <label>发起时间</label>
                          <div>
                            {formatDate(item.createTime, 'YYYY-MM-DD HH:mm:ss')}
                          </div>
                        </li>
                      </ul>
                      {item.companyCode === companyCode &&
                        item.checkedStatus === 0 &&
                        item.checkUserId === User.getUserInfo().id && (
                          <div className="footer">
                            <WorkflowButtons
                              companyCode={companyCode}
                              id={item.billXkNo}
                              workflow={{
                                arrBtn: item.arrBtn,
                                billXkNoField: 'billXkNo'
                              }}
                              detail={item}
                              sourcePage="approveList"
                              onChange={() => {
                                self.search(true, 1);
                              }}
                            />
                          </div>
                        )}
                    </div>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
      <Modal></Modal>
    </Page>
  );
}

ApproveList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(ApproveList);
